const sight2DimLabels = {
    fr: {
        f1: "Contributions au travail",
        f2: "Relation aux collègues",
        f3: "Relation à la carrière",
        f4: "Relation au marché du travail",
        sg: "Score d'adaptation global",
        c1: "Leadership",
        c2: "Engagement",
        c3: "Management",
        c4: "Commercial",
        t1: "Collaborer et contribuer",
        t2: "Organiser et contrôler",
        t3: "Orienter et propulser",
        t4: "Dépasser le cadre",
        t5: "Prendre des risques",
        t6: "Évaluer justement ses compétences",
        t: "Confrontation à la tâche",
        e: "Centration sur l’émotion",
        s: "Centration sur soutien social"
    },
    en: {
        f1: "Contributions au travail",
        f2: "Relation aux collègues",
        f3: "Relation à la carrière",
        f4: "Relation au marché du travail",
        sg: "Score d'adaptation global",
        c1: "Leadership",
        c2: "Engagement",
        c3: "Management",
        c4: "Commercial",
        t1: "Collaborer et contribuer",
        t2: "Organiser et contrôler",
        t3: "Orienter et propulser",
        t4: "Dépasser le cadre",
        t5: "Prendre des risques",
        t6: "Évaluer justement ses compétences",
        t: "Confrontation à la tâche",
        e: "Centration sur l’émotion",
        s: "Centration sur soutien social"
    }
}
export default sight2DimLabels
